module.exports = "/_next/static/images/SafariEnableMediaRecorder3-ec86f4e0468fc1cca9deb2972acffd5a.png";